export function isInIframe() {
  return window.self !== window.top
}
